// src/components/Logo.jsx
export default function Logo({ className = "w-10 h-10" }) {
  return (
    <img
      src="/images/2s-pay.png"
      alt="2S-PAY"
      className={className}
    />
  );
}
